<template>
  <v-menu
    v-if="isAuthenticated && !showScreenshotTool && !isE2ETest"
    :nudge-left="10"
    offset-x
    left
  >
    <template #activator="{ on, value }">
      <v-btn
        id="bm-support-activator"
        :style="{ opacity: value ? 1 : 0.5 }"
        fab
        small
        class="no-print"
        v-on="on"
      >
        <bm-icon icon="ContactSupport" />
      </v-btn>
    </template>

    <v-card>
      <v-list>
        <v-list-item @click="showScreenshotTool = true">
          <v-list-item-title>
            <bm-icon icon="BugReport" class="pr-2 brand-01" />
            {{ $m.support_report_a_bug }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          :href="$m.support_feature_url"
          target="_blank"
          rel="noopener noreferrer"
        >
          <v-list-item-title>
            <bm-icon icon="LightbulbOutline" class="pr-2 brand-01" />
            {{ $m.support_feature_request }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          :href="resolvedHelpLink"
          target="_blank"
          rel="noopener noreferrer"
        >
          <v-list-item-title>
            <bm-icon icon="MenuBook" class="pr-2 brand-01" />
            {{ $m.support_documents }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>

  <screen-shot-tool
    v-else-if="showScreenshotTool"
    :value.sync="showScreenshotTool"
  />
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import ScreenShotTool from "@/components/controls/support/ScreenShotTool.vue";
import userStore from "@/store/modules/userStore";
import { isRunningEndToEndTests } from "@/app/ui/utilities";
import appStore from "@/store/modules/appStore";

const showScreenshotTool = ref(false);

const isAuthenticated = computed(
  () => userStore.isAuthenticatedWithSelectedTenant.value
);

// hide support widget in e2e tests
const isE2ETest = isRunningEndToEndTests();

const resolvedHelpLink = appStore.resolvedHelpLink;
</script>

<style lang="sass" scoped>
@import "src/sass/colours"

.brand-01
  color: $bm-color-brand01

// Using an id to battle CSS specificity
#bm-support-activator
  position: fixed
  top: calc(50vh - 20px)
  right: 0
  color: white !important
  background-color: $bm-color-brand01 !important
  z-index: 1000
</style>
